import { render, staticRenderFns } from "./POPUP.vue?vue&type=template&id=31409c26&scoped=true"
import script from "./POPUP.vue?vue&type=script&lang=ts"
export * from "./POPUP.vue?vue&type=script&lang=ts"
import style0 from "./POPUP.vue?vue&type=style&index=0&id=31409c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31409c26",
  null
  
)

export default component.exports